import React from 'react';
export function ServiceAreaSection() {
  return <section className="py-16 sm:py-20 bg-background-gray-light" data-id="element-132">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <h2 className="text-3xl font-heading text-text-title mb-10 text-center" data-id="element-134">
          Your local mortgage broker
        </h2>
        <div className="space-y-6 text-lg text-text-default leading-relaxed" data-id="element-135">
          <p data-id="element-136">
            When you need a mortgage broker in Secret Harbour, Rockingham,
            Mandurah or anywhere nearby, using a mortgage broker such as myself
            will reduce the time, energy and frustration spent searching for
            home finance. With thousands of loan options, finding the right loan
            can be an overwhelming task for many mortgage borrowers. I will work
            hard to save your valuable time and take the stress out of your next
            home loan application.
          </p>
          <p data-id="element-137">
            By utilising your local mortgage broker's knowledge and experience,
            you can ensure the loan that you settle on will not only provide you
            with the funds you need, but will also fit your lifestyle perfectly.
            Everyone is different and this holds true when it comes to obtaining
            finance. If you're in the market for a mortgage broker in or around
            Secret Harbour, Rockingham or Mandurah who can help with a
            traditional home purchase, or you're seeking a professional to
            assist you with a specialised loan: I can help.
          </p>
          <p data-id="element-138">
            As a local Mortgage Australia Broker, maintaining a great reputation
            in my home area of Secret Harbour, Rockingham and Mandurah is
            crucial to the continued success of my business and my standing in
            the community. If you are looking for a mortgage broker in Secret
            Harbour, Rockingham, Mandurah or nearby, call me today or send me a
            message via the form below so I can help you to find the financial
            solution for your needs.
          </p>
        </div>
      </div>
    </section>;
}